import { CartItem, OrderItemToppings } from './types';

export const findSameItems = (items: CartItem[], id: string) => items.filter((item) => item.id === id);

export const isSameToppings = (sameToppings: OrderItemToppings, payloadToppings: OrderItemToppings) =>
  JSON.stringify(sameToppings) === JSON.stringify(payloadToppings);

export const updateItemToppings = (toppings: OrderItemToppings) =>
  toppings.map((item) => ({
    ...item,
    count: item.count + 1,
  }));

export const findItemIndex = (items: CartItem[], temporaryOrderId: string) =>
  items.findIndex((item) => item.temporaryOrderId === temporaryOrderId);
